import "@/app.css";
import "@/assets/styles.scss";
import "primeicons/primeicons.css";

// OTHERS
import { createApp, markRaw, reactive } from "vue";
import Aura from "@primevue/themes/aura";
import * as Sentry from "@sentry/vue";
import { createHead } from "@unhead/vue";
// import Echo from "laravel-echo";
import { createPinia } from "pinia";
import BadgeDirective from "primevue/badgedirective";
import PrimeVue from "primevue/config";
import ConfirmationService from "primevue/confirmationservice";
import ConfirmDialog from "primevue/confirmdialog";
import Toast from "primevue/toast";
import ToastService from "primevue/toastservice";
import ToggleSwitch from "primevue/toggleswitch";
import Tooltip from "primevue/tooltip";
import Pusher from "pusher-js";

import i18nInstance from "@/i18n";

import App from "./App.vue";
import router from "./routes.js";

if (import.meta.env.VITE_PUSHER_APP_KEY) {
  window.Pusher = Pusher;

  // window.Echo = new Echo({
  //   broadcaster: "pusher",
  //   key: import.meta.env.VITE_PUSHER_APP_KEY,
  //   cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
  //   forceTLS: true,
  // });
}

const app = createApp(App)
  .use(PrimeVue, {
    theme: {
      preset: Aura,
      options: {
        prefix: "p",
        darkModeSelector: "system",
        cssLayer: false,
      },
    },
  })
  .use(ConfirmationService)
  .use(ToastService)
  .component("ConfirmDialog", ConfirmDialog)
  .component("Toast", Toast)
  .component("ToggleSwitch", ToggleSwitch);

if (!import.meta.env.VITE_SENTRY_DSN) {
  // TODO: the error should be displayed if we have env for local or prod, and only in prod or dev, not in local
  // console.error("Sentry DSN is not configured. Please set VITE_SENTRY_DSN in your environment variables.");
} else {
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    sendDefaultPii: true,
    // integrations: [],
  });
}

app.config.globalProperties.$appState = reactive({
  isRTL: true,
  isNewThemeLoaded: false,
  layoutMode: "light",
});

app.directive("badge", BadgeDirective);
app.directive("tooltip", Tooltip);

app.use(i18nInstance);

const pinia = createPinia();

// Create a global head instance
const head = createHead();

pinia.use(({ store }) => {
  store.router = markRaw(router);
});

app.use(pinia);
app.use(head);
app.use(router);

app.mount("#app");
